// this file is automatically generated by version.generator.ts script
export const versions = {
  version: '4.90.0-beta.82a5bdc41',
  revision: '82a5bdc41',
  branch: 'develop',
  date: 'Wed, 05 Aug 2026 15:48:16 GMT'
};